module.exports = __webpack_public_path__ + "static/media/add_connection_icon.7402aa02.svg";